var PROFILE_DOMAIN = process.env.REACT_APP_PROFILE_REDIRECT_DOMAIN;
var S7_ID_URL = process.env.REACT_APP_S7_ID_URL;
/**
 * Формирует ссылку для перехода на сервис авторизации.
 *
 * Если переменная окружения, указывающая на стенд S7 ID определена - в качестве сервиса авторизации используется S7 ID.
 * В противном случае для авторизации используется Legacy MyProfile.
 *
 * @param redirectUrl - Ссылка для возврата после авторизации на профиле (опциональный).
 * @param loggedIn - При значении `true` принудительно возвращает ссылку на приложение профиля.
 * */
export var getProfileLinkByAuthState = function (redirectUrl, loggedIn) {
    if (loggedIn === void 0) { loggedIn = false; }
    if (loggedIn) {
        return PROFILE_DOMAIN;
    }
    var redirectUri = redirectUrl
        ? encodeURIComponent(redirectUrl)
        : '';
    if (S7_ID_URL) {
        if (redirectUri) {
            var params = new URLSearchParams({
                origin: 'portal',
                redirectUri: redirectUri,
                close: redirectUri
            });
            return "".concat(S7_ID_URL, "/?").concat(params);
        }
        return S7_ID_URL;
    }
    if (redirectUri) {
        return "".concat(PROFILE_DOMAIN, "/login/?redirect=").concat(redirectUri);
    }
    return PROFILE_DOMAIN;
};
